export default function createVariables({ mealId }) {
    const variables = {
        id: mealId,
    };

    return variables;
}
